import { createResourceApi } from 'resources/ResourceApi';
import { PaymentModeApiItem } from 'typings/api';

export default createResourceApi<PaymentModeApiItem>('payment_modes');
